import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {BASE_URL, CONTENT_URL, modelSearch} from '../actions';


const ModelsPage = (props) => {
    return <div>
        <h1>Modeller <Link to="/registrera/modell" className="ml-2"><i className="fa-light fa-circle-plus small"></i></Link></h1>
        <div className="form form-group form-search">
            <input type="text" className="form-control" placeholder="Sök på namn, kön, ålder, hemort m.fl" value={props.search} onChange={props.onSearchChange} />
        </div>
        <div className="thumb-group mt-4">
          <div className="row row-sm">
              {props.models && props.models.map((model, i) => {
                return <div className="col-3" key={i}>
                  <Link to={ '/models/' + model.id } className="thumb" style={ { backgroundImage: 'url('+model.profile+')' } }>
                      {model.contracts > 0 && <span className="badge badge-pill badge-warning">{model.contracts}st kontrakt skrivna {(new Date().getFullYear())}</span>}
                    <div className="caption">
                        {model.name}
                    </div>
                  </Link>
                </div>
              })}
          </div>
        </div>
      </div>;
}

export default connect(state => state.modelState, (dispatch) => {
    return {
        onSearchChange: (e) => {
            var value = e.target.value;
            modelSearch(dispatch, value);
        }
    }
})(ModelsPage);